import { useTranslation } from 'react-i18next';

const statusColors = {
    COMPLETED: '#45c343',
    ACKNOWLEDGED: '#4d5ec4',
    REACHED: '#1c9dff',
    STARTED: '#8fa9b9',
    CANCELED: '#FF0000',
    FAILED: '#FF0000',
    FAILED_PAYMENT: '#FF0000',
    DECLINED: '#FF69B4',
    IN_TRANSIT: '#393d44',
    CREATED: '#8fa9b9',
    PENDING_PROLONGATION_PAYMENT: '#ff8a00',
    DEFAULT: '#ff8a00',
};


function StatusBadge({ status, namespace = 'status', style = 'desktop' }) {
    const { t, i18n } = useTranslation(['dashboard', 'commande', 'bill']);

    const title = t(`${namespace}.${status}`, status);
    const color = statusColors[status] || statusColors.DEFAULT;

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>

            <span
                style={{
                    backgroundColor: color,
                    color: '#fff',
                    padding: '5px',
                    borderRadius: '12px',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                    ...(style === 'desktop'
                    ? { maxWidth: '80px' }
                    : {}),
                }}
                title={title}
            >
                {title}
            </span>
        </div>
    );
}
export default StatusBadge; 